// engagement-components/config.jsx
export const apiUrl  = process.env.REACT_APP_API_URL       || "http://localhost:3000/api/pos";
export const cdnUrl  = process.env.REACT_APP_CDN_URL        || "https://netshine-assets.blr1.cdn.digitaloceanspaces.com";
export const surveyBaseUrl = process.env.REACT_APP_SURVEY_BASE_URL || "https://secure.netshineoffice.com";

export const authHeaders = () => ({
  headers: {
    Authorization: localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : "",
    "Content-Type": "application/json",
  },
});

// Use this for file uploads — MUST NOT set Content-Type, browser sets multipart boundary
export const uploadHeaders = () => ({
  headers: {
    Authorization: localStorage.getItem("token") ? `Bearer ${localStorage.getItem("token")}` : "",
    // Content-Type intentionally omitted — browser sets it with the multipart boundary
  },
});

export const getCompanyId   = () => localStorage.getItem("companyid")   || "";
export const getCompanyLogo = () => localStorage.getItem("companylogo") || "";
export const getCompanyName = () => localStorage.getItem("companyname") || "Our Hotel";

// ─── SAMPLE / FALLBACK DATA ──────────────────────────────────────────────────
export const SAMPLE = {
  stats: {
    totalSent: 12480, deliveryRate: 94.2, clickRate: 38.7,
    conversions: 312, revenue: 284500, activeJourneys: 6,
  },
  funnel: [
    { stage: "Sent",      count: 12480 },
    { stage: "Delivered", count: 11756 },
    { stage: "Clicked",   count: 4551  },
    { stage: "Opened",    count: 3820  },
    { stage: "Converted", count: 312   },
  ],
  journeys: [
    { id: "j1", name: "Birthday Celebration",    trigger: "Birthday",    steps: 3, status: "Active", ctr: 42.3, conversion: 18.1, lastRun: "2025-01-14T08:00:00Z", nextRun: "2025-01-15T08:00:00Z" },
    { id: "j2", name: "Anniversary Delight",      trigger: "Anniversary", steps: 2, status: "Active", ctr: 36.8, conversion: 14.5, lastRun: "2025-01-13T09:00:00Z", nextRun: "2025-01-16T09:00:00Z" },
    { id: "j3", name: "Post Check-out Follow-up", trigger: "Check-out",   steps: 4, status: "Paused", ctr: 28.2, conversion: 9.8,  lastRun: "2025-01-10T10:00:00Z", nextRun: null },
    { id: "j4", name: "Welcome Check-in",         trigger: "Check-in",    steps: 2, status: "Active", ctr: 55.1, conversion: 22.3, lastRun: "2025-01-14T07:30:00Z", nextRun: "2025-01-15T07:30:00Z" },
  ],
  campaigns: [
    { id: "c1", name: "New Year Special Offer",     channel: "WhatsApp", audience: 1240, sent: 1238, clicks: 512, conversions: 89, revenue: 42300, status: "Completed", createdAt: "2025-01-01" },
    { id: "c2", name: "Weekend Spa Package",         channel: "SMS",      audience: 680,  sent: 672,  clicks: 201, conversions: 34, revenue: 18900, status: "Active",    createdAt: "2025-01-10" },
    { id: "c3", name: "Loyalty Members Flash Sale", channel: "Email",    audience: 320,  sent: 318,  clicks: 145, conversions: 28, revenue: 15600, status: "Scheduled", createdAt: "2025-01-13" },
  ],
  templates: [
    { id: "t1", name: "Birthday Greeting",   channel: "WhatsApp", content: "Happy Birthday {{guest_name}}! 🎂 Celebrate with us at {{hotel_name}}. Enjoy a special discount → {{link}}", linkType: "landing", landingPageId: "lp3" },
    { id: "t2", name: "Check-out Thank You", channel: "WhatsApp", content: "Dear {{guest_name}}, thank you for staying at {{hotel_name}}! Share your feedback → {{link}}", linkType: "feedback", surveyId: "s1" },
    { id: "t3", name: "Weekend Deal",        channel: "SMS",      content: "Hi {{guest_name}}! Exclusive weekend offer at {{hotel_name}}. Book now: {{link}}", linkType: "landing", landingPageId: "lp1" },
    { id: "t4", name: "New Year Special",    channel: "WhatsApp", content: "🎉 Happy New Year {{guest_name}}! Ring in 2025 with us at {{hotel_name}} — exclusive celebration package: {{link}}", linkType: "landing", landingPageId: "lp2" },
  ],
  landingPages: [
    { id: "lp1", title: "Weekend Spa Package",      slug: "weekend-spa",     status: "Active", views: 320,  clicks: 89  },
    { id: "lp2", title: "New Year Celebration",     slug: "new-year-2025",   status: "Active", views: 1240, clicks: 412 },
    { id: "lp3", title: "Birthday Special Room",    slug: "birthday-room",   status: "Draft",  views: 0,    clicks: 0   },
  ],
  guests: [
    { id: "g1", name: "Rahul Sharma",  phone: "+91 98765 43210", email: "rahul@example.com",  dob: "1990-01-15", anniversary: "2018-01-16", city: "Mumbai",    room_type: "Deluxe", lastInteraction: "2025-01-10", source: "PMS",    status: "Active", tags: ["VIP","Loyalty Member"] },
    { id: "g2", name: "Priya Mehta",   phone: "+91 87654 32109", email: "priya@example.com",  dob: "1985-07-22", anniversary: "2012-01-16", city: "Delhi",     room_type: "Suite",  lastInteraction: "2025-01-12", source: "CSV Import", status: "Active", tags: ["Regular"] },
    { id: "g3", name: "Arjun Verma",   phone: "+91 76543 21098", email: "arjun@example.com",  dob: "1992-04-08", anniversary: null,          city: "Pune",      room_type: "Deluxe", lastInteraction: "2025-01-08", source: "Manual", status: "Active", tags: ["First Visit"] },
    { id: "g4", name: "Neha Kapoor",   phone: "+91 65432 10987", email: "neha@example.com",   dob: "1988-12-30", anniversary: "2015-06-14", city: "Bangalore", room_type: "Standard",lastInteraction: "2025-01-05", source: "QR Registration", status: "Active", tags: ["VIP"] },
    { id: "g5", name: "Vikram Singh",  phone: "+91 54321 09876", email: "vikram@example.com", dob: "1975-09-18", anniversary: "2005-02-28", city: "Mumbai",    room_type: "Suite",  lastInteraction: "2024-12-28", source: "Feedback Form", status: "Active", tags: ["Corporate"] },
  ],
  credits: {
    balance: 8420, used: 12480, total: 20900,
    history: [
      { date: "2025-01-01", amount: 5000,  type: "purchase", note: "Starter Pack" },
      { date: "2025-01-05", amount: -3200, type: "usage",    note: "Campaign: New Year Special" },
      { date: "2025-01-10", amount: 10000, type: "purchase", note: "Growth Pack" },
      { date: "2025-01-14", amount: -3800, type: "usage",    note: "Journeys: Birthday + Anniversary" },
    ],
  },
  channelStats: [
    { channel: "WhatsApp", sent: 9840, delivered: 9320, clicked: 3840, converted: 248, revenue: 198000 },
    { channel: "SMS",      sent: 1840, delivered: 1760, clicked: 480,  converted: 42,  revenue: 54000  },
    { channel: "Email",    sent: 800,  delivered: 676,  clicked: 231,  converted: 22,  revenue: 32500  },
  ],
};
